module.exports = __webpack_public_path__ + "img/web_neipu_3.10456ecb.jpg";